import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useArchiveDocumentReportMutation } from '../hooks/useArchiveDocumentReportMutation'
import {
  type DocumentReport,
  useInvalidateDocumentReportsInfiniteQuery,
} from '../hooks/useDocumentReportsInfiniteQuery'

export type ArchiveButtonProps = {
  documentReport: DocumentReport
}

export const ArchiveButton = ({ documentReport }: ArchiveButtonProps) => {
  const { t } = useTranslation()
  const invalidateDocumentReportsInfiniteQuery =
    useInvalidateDocumentReportsInfiniteQuery()
  const logEvent = useLogEvent()
  const archiveDocumentReportMutation = useArchiveDocumentReportMutation({
    onSuccess: () => {
      invalidateDocumentReportsInfiniteQuery()
      logEvent('Delete document')
    },
  })
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    archiveDocumentReportMutation.mutate(documentReport.id)
  }, [archiveDocumentReportMutation, documentReport.id])

  return (
    <StyledButton
      disabled={archiveDocumentReportMutation.isPending}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    >
      {t('delete_4')}
    </StyledButton>
  )
}
